export const setBrowserTabTitle = (title: string) => {
  document.title = title
}
